// Fixture para datos de prueba en modo desarrollo
export const contratosFixture = {
  "ResponseCode": 200,
  "ResponseDetail": "Ok",
  "Result": {
    "__type": "AcuerdosTarifariosResponse:#Consorcio.Transar.Entities.Common.Response",
    "Contratos": [
      {
        "Id": 1,
        "Nombre": "CSS-003 -2014",
        "Anexos": [
          {
            "Id": 1377961,
            "Nombre": "ANEXO DEL CONTRATO No D1 PROGRAMA PEDIATRICO",
            "FechaFin": "10/04/2026",
            "FechaInicio": "10/04/2025",
            "OtrosAspectos": "Se crea acuerdo correspondiente al año 2025 para la EPS de prueba (Son las observaciones que van en el documento justo antes de la Vigencia)",
            "TipoAcuerdo": "ANEXO SERVICIOS DE SALUD"
          }
        ]
      }
    ],
    "HayAcuerdos": true
  }
};